import CrossCloudCostMonitor from '../components/admin/CrossCloudCostMonitor';

export default function CrossCloudCostMonitorPage() {
  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <CrossCloudCostMonitor />
      </div>
    </div>
  );
}
